import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { SideNav, SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { NavConfig } from '../constants/NavConfig';
import { DEFAULT_ROUTE, Paths } from '../constants/Paths';
import { trackInteraction } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const NavigationItems = ({
  isExpanded,
  onNavigate
}) => {
  const history = useHistory();
  const {
    pathname: currentRoute
  } = useLocation();
  const navigate = useCallback(path => () => {
    trackInteraction('sidebar-nav-clicked', {
      destination: path
    });
    history.push(path);
    onNavigate === null || onNavigate === void 0 || onNavigate();
  }, [history, onNavigate]);
  const resolvedRoute = currentRoute === Paths.DEFAULT ? DEFAULT_ROUTE : currentRoute;
  const isActivePath = useCallback(path => resolvedRoute === path, [resolvedRoute]);
  const expandedNavItems = useMemo(() => {
    return NavConfig.map((navItem, index) => {
      const {
        messageKey,
        icon,
        path
      } = navItem;
      return /*#__PURE__*/_jsx(SideNavItem, {
        "data-test-id": `nav-item-${path.replace(/\//g, '')}`,
        iconLeft: icon,
        marginBlockStart: index > 0 ? '300' : undefined,
        onClick: navigate(path),
        active: isActivePath(path),
        title: /*#__PURE__*/_jsx(View, {
          marginInlineStart: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: messageKey
          })
        })
      }, messageKey);
    });
  }, [navigate, isActivePath]);
  const collapsedNavItems = useMemo(() => {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      children: NavConfig.map(navItem => {
        const {
          messageKey,
          icon,
          path
        } = navItem;
        return /*#__PURE__*/_jsx(IconButton, {
          "data-test-id": `nav-item-${path.replace(/\//g, '')}`,
          use: isActivePath(path) ? 'tertiary-light' : 'transparent',
          marginInlineStart: "0",
          tooltip: I18n.text(messageKey),
          placement: "right",
          onClick: navigate(path),
          children: icon
        }, messageKey);
      })
    });
  }, [navigate, isActivePath]);
  return /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(SideNav, {
      paddingInline: "300",
      children: isExpanded ? expandedNavItems : collapsedNavItems
    })
  });
};